require("./comforttechnology.scss");